/** Initials for an avatar fallback (name, email as backup). Shared between web_admin
 *  and web_account - one user must show the same initials in both apps. */
export function userInitials(name: string, email = ""): string {
  return (name || email)
    .split(/\s+/)
    .map((p) => p[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();
}

/** Bytes -> human readable (adaptive B/KB/MB/GB). Shared: web_admin + web_account. */
export function formatBytes(bytes: number, digits = 1): string {
  const b = Math.max(0, bytes || 0);
  if (b < 1024) return `${b} B`;
  if (b < 1024 * 1024) return `${(b / 1024).toFixed(digits)} KB`;
  if (b < 1024 * 1024 * 1024) return `${(b / (1024 * 1024)).toFixed(digits)} MB`;
  return `${(b / (1024 * 1024 * 1024)).toFixed(digits)} GB`;
}
